import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApi } from "@/api/useApi";
import type { ReportDetail } from "@/api/types";
import { Icon } from "@/components/Icon";
import { todayIso } from "@/format";

export function NewReportPage() {
  const api = useApi();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [purpose, setPurpose] = useState("");
  const [start, setStart] = useState(todayIso());
  const [end, setEnd] = useState(todayIso());
  const [error, setError] = useState<string>();
  const [busy, setBusy] = useState(false);

  return (
    <div className="narrow">
      <Link className="back" to="/">
        <Icon name="chevronLeft" size={18} />
        Reports
      </Link>
      <form
        className="card stack"
        onSubmit={(event) => {
          event.preventDefault();
          setBusy(true);
          setError(undefined);
          api
            .post<ReportDetail>("/api/expenses/reports", {
              title,
              purpose: purpose.trim() === "" ? null : purpose,
              periodStart: start,
              periodEnd: end,
            })
            .then((report) => {
              void navigate(`/reports/${report.id}`, { replace: true });
            })
            .catch((caught: unknown) => {
              setError(caught instanceof Error ? caught.message : String(caught));
              setBusy(false);
            });
        }}
      >
        <h1>New expense report</h1>
        <label>
          Trip or event
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            placeholder="NYC client visit"
            autoFocus
          />
        </label>
        <label>
          Purpose <span className="optional">optional</span>
          <input
            value={purpose}
            onChange={(e) => setPurpose(e.target.value)}
            placeholder="Quarterly review with Acme"
          />
        </label>
        <div className="split">
          <label>
            Starts
            <input
              type="date"
              value={start}
              onChange={(e) => {
                setStart(e.target.value);
                if (end < e.target.value) setEnd(e.target.value);
              }}
              required
            />
          </label>
          <label>
            Ends
            <input
              type="date"
              value={end}
              min={start}
              onChange={(e) => setEnd(e.target.value)}
              required
            />
          </label>
        </div>
        {error && (
          <div className="error" role="alert">
            {error}
          </div>
        )}
        <button className="btn form-submit" disabled={busy}>
          {busy ? "Creating…" : "Create report"}
        </button>
      </form>
    </div>
  );
}
